import React, { useRef } from 'react';
import { Card, IconButton } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close';
import StTextField from '../misc/textField';
import StButton from "../misc/button";
import { withFirebase } from '../Firebase'
import CircularProgress from '@material-ui/core/CircularProgress';

const EditSoundtrailScreen = (props) => (
    EditSoundtrailScreenWithFirebase(props)
)

const EditSoundtrailScreenBase = props => {

    const [name, setName] = React.useState("")
    const [stxUrl, setStxUrl] = React.useState("")
    const [tags, setTags] = React.useState("")
    const [loading, setLoading] = React.useState(0)
    const [refreshAlert, setRefreshAlert] = React.useState(false)
    const [file, setFile] = React.useState({ name: "Update Thumbnail" })

    if (loading === 0) {
        props.firebase.getSoundtrailData(props.id).then((d) => {
            const data = d.data()
            setStxUrl(data.soundtrailKmlFileUrl.split('/').pop())
            setName(data.name)
            setTags(data.tags)
        });
        setLoading(1)
    }

    const handleEdit = async () => {
        setLoading(2)
        const { firebase } = props;
        const userData = await firebase.getUserData()
        const data = userData.data();


        let editedData = {
            name: name,
            soundtrailKmlFileUrl: data.stxUrl + stxUrl,
            tags: tags,
        }

        if (file.size !== undefined) {
            await firebase.setThumbnail(file.name, file);
            editedData.tileImageUrl = file.name;
        }

        firebase.editSoundtrail(props.id, editedData).then(() => { props.onClose(); window.location.reload(); })
    }

    const fileInputRef = useRef(null);

    const handleBtnClick = () => {
        fileInputRef.current.click();
    }

    const handleEmbedLink = () => {
        console.log(props)
        window.open("https://stxdemo.firebaseapp.com/?stUrl=" + props.stxUrl)
    }

    const handleSoundWalk = () => {
        window.open(props.open)
        setRefreshAlert(true)
    }

    const handleFileNameChange = () => {
        setFile(fileInputRef.current.files[0]);
    }

    const changeName = (newName) => {
        // if (stxUrl === name.replace(/ /g, "_") + ".stx" || stxUrl === "") {
        //     setStxUrl(newName.replace(/ /g, "_") + ".stx")
        // }
        setName(newName)
    }

    if (loading === 2) {
        return (
            <div className="App">
                <Card style={{ height: "550px", width: "400px", position: "relative" }}>
                    <CircularProgress style={{ marginTop: "150px" }} />
                </Card>
            </div>
        )
    }

    const isInvalid =
        name === '' ||
        stxUrl === '';
    return (
        <div className="App">
            <Card style={{ height: "620px", width: "400px", position: "relative" }}>
                <IconButton style={{ left: "-170px" }} onClick={() => { props.onClose() }} ><CloseIcon /></IconButton>
                <div>
                    <h1 style={{ marginTop: "-10px" }}>Edit Soundtrail</h1>
                    <br />
                </div>
                <StTextField id="name" style={{ width: "300px" }} label="Soundtrail Name" value={name} onChange={changeName} />
                <br />
                <br />
                <br />
                <StTextField id="stxUrl" style={{ width: "300px" }} label="STX File Name" value={stxUrl} onChange={setStxUrl} />
                <br />
                <br />
                <br />
                <StTextField id="tags" style={{ width: "300px" }} label="Tags" value={tags} onChange={setTags} />
                <br />
                <br />
                <StButton style={{ margin: "5px" }} onClick={handleBtnClick} color="secondary" text={file.name} />
                <br />
                <br />
                <StButton style={{ margin: "5px" }} onClick={handleEmbedLink} color="secondary" text="Preview / Embed" />
                <br />
                <br />
                <StButton onClick={handleEdit} text="Publish" isDisabled={isInvalid} style={{ margin: "5px", backgroundColor:refreshAlert ? "#ffaa33" : "#eeeeee" }} />
                <StButton onClick={handleSoundWalk} text="Edit SoundWalk" style={{ margin: "5px" }} />
                <br />
                {refreshAlert ? "Publish your changes to make them visible in the app." : ""}
                <input onChange={handleFileNameChange} ref={fileInputRef} type="file" style={{ visibility: "hidden" }} />
            </Card>
        </div>
    );
}

const EditSoundtrailScreenWithFirebase = withFirebase(EditSoundtrailScreenBase);

export default EditSoundtrailScreen